/*
 * @Author: 刘怡
 * @Date: 2022-05-09 09:25:30
 * @Last Modified by: 刘怡
 * @Last Modified time: 2022-05-09 09:27:47
 */
import request from '@/utils/request2';
export function reportList(data) {
  return request.post('admin/claims-management/list', data);
}
export function reportDetail(data) {
  return request.post('admin/claims-management/detail', data);
}
export function policyDetail(data) {
  return request.post('admin/policy/detail', data);
}
export function claimsManagementStore(data) {
  return request.post('admin/claims-management/store', data);
}